// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4bb160b6","732":"fa4b5590","977":"bf212ead"}[chunkId] + ".chunk.js";
};